export const isObjectEmpty = (value) => {
  for (const prop in value) {
    if (Object.hasOwn(value, prop)) return false
  }
  return true
}
